import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=8fb9492c&scoped=true&"
import script from "./SignUpView.vue?vue&type=script&lang=js&"
export * from "./SignUpView.vue?vue&type=script&lang=js&"
import style0 from "./SignUpView.vue?vue&type=style&index=0&id=8fb9492c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb9492c",
  null
  
)

export default component.exports